import { QueryBuilder } from './queryBuilder';
import { UrlBuilder } from '../../../builders/urlBuilder';
import { Orion } from '../../../orion';
export class RelationQueryBuilder extends QueryBuilder {
    constructor(relationConstructor, parent) {
        super(relationConstructor);
        this.modelConstructor = relationConstructor;
        this.baseUrl = UrlBuilder.getRelationResourceUrl(parent, relationConstructor);
        this.httpClient = Orion.makeHttpClient(this.baseUrl);
    }
}
//# sourceMappingURL=relationQueryBuilder.js.map